/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Usage_RestrictionsInputs */

const en_admin_discounts_usage_restrictions = /** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage Restrictions`)
};

const de_admin_discounts_usage_restrictions = /** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbeschränkungen`)
};

const es_admin_discounts_usage_restrictions = /** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restricciones de uso`)
};

const fr_admin_discounts_usage_restrictions = /** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restrictions d'utilisation`)
};

const nl_admin_discounts_usage_restrictions = /** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruiksbeperkingen`)
};

/** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */
const it_admin_discounts_usage_restrictions = en_admin_discounts_usage_restrictions;

/** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */
const pt_br2_admin_discounts_usage_restrictions = en_admin_discounts_usage_restrictions;

/** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */
const pl_admin_discounts_usage_restrictions = en_admin_discounts_usage_restrictions;

/** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */
const hu_admin_discounts_usage_restrictions = en_admin_discounts_usage_restrictions;

/** @type {(inputs: Admin_Discounts_Usage_RestrictionsInputs) => LocalizedString} */
const ro_admin_discounts_usage_restrictions = en_admin_discounts_usage_restrictions;

/**
* | output |
* | --- |
* | "Usage Restrictions" |
*
* @param {Admin_Discounts_Usage_RestrictionsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_usage_restrictions = /** @type {((inputs?: Admin_Discounts_Usage_RestrictionsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Usage_RestrictionsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_usage_restrictions(inputs)
	if (locale === "de") return de_admin_discounts_usage_restrictions(inputs)
	if (locale === "es") return es_admin_discounts_usage_restrictions(inputs)
	if (locale === "fr") return fr_admin_discounts_usage_restrictions(inputs)
	if (locale === "nl") return nl_admin_discounts_usage_restrictions(inputs)
	if (locale === "it") return it_admin_discounts_usage_restrictions(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_usage_restrictions(inputs)
	if (locale === "pl") return pl_admin_discounts_usage_restrictions(inputs)
	if (locale === "hu") return hu_admin_discounts_usage_restrictions(inputs)
	return ro_admin_discounts_usage_restrictions(inputs)
});
export { admin_discounts_usage_restrictions as "admin.discounts.usage_restrictions" }